import React from "react";
import { SvgIcon } from "./SvgIcon";

export function ConfirmModal(props: {
  title: string;
  body: string;
  confirmText: string;
  cancelText: string;
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}) {
  if (!props.isOpen) return null;

  return (
    <div className="modalBackdrop" role="dialog" aria-modal="true">
      <div className="modalCard" style={{ width: "min(520px, 92vw)" }}>
        <div className="modalHeader">
          <div className="modalTitle">{props.title}</div>
          <button className="iconBtn" onClick={props.onCancel} title={props.cancelText}>
            <SvgIcon name="x-circle" title="Close" />
          </button>
        </div>
        <div className="modalBody">
          <div className="small" style={{ whiteSpace: "pre-wrap", wordBreak: "break-all" }}>{props.body}</div>
        </div>
        <div className="modalFooter">
          <button className="btn" onClick={props.onCancel}>
            {props.cancelText}
          </button>
          <div style={{ flex: 1 }} />
          <button className="btn primary" onClick={props.onConfirm}>
            {props.confirmText}
          </button>
        </div>
      </div>
    </div>
  );
}
